<template>
  <table
    class="fm-report__table"
    :style="{
      'border-top-width': element.options.borderWidth + 'px',
      'border-top-color': element.options.borderColor,
      'border-left-width': element.options.borderWidth + 'px',
      'border-left-color': element.options.borderColor,
      width: element.options.width || '100%',
    }"
    v-if="!this.element.options.hidden"
  >
    <tr :key="rIndex" v-for="(row, rIndex) in element.rows">
      <td
        v-for="(column, i) in row.columns"
        :key="rIndex + '-' + i"
        :style="{
          'border-right-width': element.options.borderWidth + 'px',
          'border-right-color': element.options.borderColor,
          'border-bottom-width': element.options.borderWidth + 'px',
          'border-bottom-color': element.options.borderColor,
          width: column.options.width,
          height: column.options.height,
        }"
        v-if="!column.options.invisible"
        :colspan="column.options.colspan"
        :rowspan="column.options.rowspan"
        class="fm-report__td"
        valign="top"
      >
        <!-- :style="{ height: `${100 / column.list.length}%` }" -->

        <div
          v-for="(columnElement, columnIndex) in column.list"
          :key="columnIndex"
          :ref="`divRef${columnElement.key}`"
        >
          <generate-advanced-item
            v-if="
              Object.keys(advancedComponents).indexOf(columnElement.type) >= 0
            "
            :key="columnElement.key"
            :models.sync="dataModels"
            :rules="rules"
            :widget="columnElement"
            :remote="remote"
            :from-son-form="false"
            :data="data"
          >
          </generate-advanced-item>
          <generate-col-item
            v-else-if="columnElement.type === 'grid'"
            :key="columnElement.key"
            :model.sync="dataModels"
            :rules="rules"
            :element="columnElement"
            :data="data"
            :remote="remote"
            :instanceJson="instanceJson"
            :ffid="ffid"
            :yyid="yyid"
            :approveTip="approveTip"
            :dataType="dataType"
            :is-mobile="isMobile"
          ></generate-col-item>
          <generate-son-form
            v-else-if="columnElement.type === 'sonform'"
            :key="columnElement.key"
            :model.sync="dataModels"
            :rules="rules"
            :element="columnElement"
            :data="data"
            :remote="remote"
            :instanceJson="instanceJson"
            :ffid="ffid"
            :yyid="yyid"
            :approveTip="approveTip"
            :dataType="dataType"
            :is-mobile="isMobile"
          ></generate-son-form>
          <generate-form-item
            v-else
            :key="columnElement.key"
            :models.sync="dataModels"
            :rules="rules"
            :widget="columnElement"
            :remote="remote"
            :from-son-form="false"
            :data="data"
            :instanceJson="instanceJson"
            :ffid="ffid"
            :yyid="yyid"
            :approveTip="approveTip"
            :dataType="dataType"
            :is-mobile="isMobile"
          ></generate-form-item>
        </div>
      </td>
    </tr>
  </table>
</template>
<script>
import { advancedComponents } from './advanced/advanced.js'
export default {
  name: 'generate-report',
  components: {},
  props: [
    'data',
    'element',
    'model',
    'rules',
    'remote',
    'instanceJson',
    'ffid',
    'yyid',
    'approveTip',
    'dataType',
    'isMobile',
  ],
  data() {
    return {
      advancedComponents,
      dataModels: this.model,
    }
  },
  watch: {
    model: {
      deep: true,
      handler() {
        this.dataModels = this.model
      },
    },
    dataModels: {
      deep: true,
      handler(val) {
        this.$emit('update:model', val)
      },
    },
  },
  computed: {
    config() {
      return this.data.config
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.element.rows.forEach(row => {
        row.columns.forEach(column => {
          column.list.forEach(columnElement => {
            if (this.$refs[`divRef${columnElement.key}`]) {
              const dom = this.$refs[`divRef${columnElement.key}`]
              dom[0].style.height = `${100 / column.list.length}%`
              if (dom && dom.length > 0) {
                const td = dom[0].parentNode
                const tr = td.parentNode

                if (tr.children.length > 1) {
                  dom[0].style.height =
                    td.clientHeight / column.list.length + 'px'
                  dom[0].style.minHeight = ''
                  dom[0].style.overflow = 'auto'
                } else {
                  dom[0].style.height = ''
                  dom[0].style.minHeight = `${100 / column.list.length}%`
                }
              }
            }
          })
        })
      })
    })
  },
  methods: {
    getStyle(key, list) {
      let style = {
        height: `${100 / list.length}%`,
      }
      const dom = this.$refs[`divRef${key}`]
      if (dom && dom.length > 0) {
        const td = dom[0].parentNode
        const tr = td.parentNode

        if (tr.children.length > 1) {
          style = {
            height: td.clientHeight / list.length + 'px',
            'min-height': '',
            overflow: 'auto',
          }
        } else {
          style = {
            height: '',
            'min-height': `${100 / list.length}%`,
          }
        }
      }
      return style
    },
  },
}
</script>
